import { Type } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import {
  ImageMedia,
  Media,
  MediaTypes,
  SvgMedia,
  VideoMedia,
} from './media.model';
import { DrupalIdentifier } from '@nx-icilalune/drupal-types';

export function createTypedEntities<T, M>(
  classMap: Map<M, Type<any>>,
  rawEntities: DrupalIdentifier[] | undefined
): T[] {
  if (!rawEntities) {
    return [];
  }
  return rawEntities
    .map((rawEntity) => {
      const modelClass: Type<any> | undefined = classMap.get(
        rawEntity.type as unknown as M
      );
      if (modelClass) {
        return createTypedEntity(modelClass, rawEntity);
      }
      return undefined;
    })
    .filter((entity) => !!entity) as T[];
}

export function createTypedEntity<T>(
  modelClass: Type<any>,
  rawEntity: DrupalIdentifier
): T | undefined {
  if (modelClass) {
    return plainToInstance(modelClass, rawEntity, {
      excludeExtraneousValues: true,
      exposeUnsetFields: false,
    });
  }
  return undefined;
}

export function createMedium(
  rawMedium: DrupalIdentifier | undefined
): Media | undefined {
  const typeMap: Map<MediaTypes, Type<any>> = new Map<MediaTypes, Type<any>>();
  typeMap.set('svgs', SvgMedia);
  typeMap.set('images', ImageMedia);
  typeMap.set('videos', VideoMedia);
  let media: Media | undefined;
  if (rawMedium) {
    const modelClass = typeMap.get(rawMedium.type as MediaTypes);
    if (modelClass) {
      media = createTypedEntity<Media>(modelClass, rawMedium);
    }
  }
  return media;
}
